/**
 * @file 辅助工具卡片
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useCallback, useRef, useState} from 'react';
import {useLatest} from 'react-use';
import Icon, {
    ArrowRightOutlined
} from '@ant-design/icons';
import A from '../../../../components/a/A';

import {ReactComponent as AutoDLIcon} from './image/AutoDL.svg';
import {ReactComponent as VisualDL} from './image/VisualDL.svg';
import {ReactComponent as EDL} from './image/EDL.svg';
import {ReactComponent as PaddleFL} from './image/PaddleFL.svg';
import {ReactComponent as PaddleX} from './image/PaddleX.svg';

export interface IToolItem {
    extraText?: string;
    iconUrl?: string;
    icon?: string;
    target?: boolean;
    text?: string;
    title?: string;
    url?: string;
    zIndex?: number;
}

const IconTextCard: React.FC<IToolItem> = props => {
    const extraRef = useRef<HTMLDivElement>(null);
    const [extraHeight, setExtraHeight] = useState<undefined | string | number>();
    const hoverStateRef = useRef<boolean>(false);
    const extraTextRef = useLatest(props.extraText);

    const mouseEnterHandle = useCallback(() => {
        if (extraRef.current && extraTextRef.current) {
            hoverStateRef.current = true;
            const height = extraRef.current.offsetHeight;
            setExtraHeight(height);
        }
    }, [setExtraHeight, extraTextRef]);
    const mouseLeaveHandle = useCallback(() => {
        if (extraRef.current) {
            hoverStateRef.current = false;
            const height = extraRef.current.offsetHeight;
            setExtraHeight((oldHeigt) => {
                if (typeof (oldHeigt) !== 'number') {
                    return height;
                }
                return oldHeigt;
            });
            setTimeout(() => {
                setExtraHeight(0);
            });
        }
    }, [setExtraHeight]);

    return (
        <div
            className="paddle-pp-icon-text-card-grid"
        >
            <div
                className="paddle-pp-icon-text-card"
                onMouseEnter={mouseEnterHandle}
                onMouseLeave={mouseLeaveHandle}
                style={{zIndex: props.zIndex}}
            >
                <A
                    href={props.url}
                    target={props.target ? '_blank' : undefined}
                    rel={props.target ? 'noopener noreferrer' : undefined}
                >
                    <div className="paddle-pp-icon-text-card-inner">
                        <div className="paddle-pp-icon-text-card-icon-wrap">
                            {props.icon === 'AutoDL'
                            && (
                                <Icon component={AutoDLIcon} />
                            )}
                            {props.icon === 'VisualDL'
                            && (
                                <Icon component={VisualDL} />
                            )}
                            {props.icon === 'EDL'
                            && (
                                <Icon component={EDL} />
                            )}
                            {props.icon === 'PaddleFL'
                            && (
                                <Icon component={PaddleFL} />
                            )}
                            {props.icon === 'PaddleX'
                            && (
                                <Icon component={PaddleX} />
                            )}
                        </div>
                        <div className="paddle-pp-icon-text-card-content">
                            <div className="paddle-pp-icon-text-card-title">
                                {props.title} <ArrowRightOutlined />
                            </div>
                            <div className="paddle-pp-icon-text-card-text">
                                {props.text}
                            </div>
                            <div
                                className="paddle-pp-icon-text-card-extratext-wrap"
                                style={{height: extraHeight}}
                            >
                                <div
                                    className="paddle-pp-icon-text-card-extratext"
                                    dangerouslySetInnerHTML={{__html: props.extraText || ''}}
                                    ref={extraRef}
                                />
                            </div>
                        </div>
                    </div>
                </A>
            </div>
        </div>
    );
};

export default IconTextCard;
